export const USER_TYPE = {
  INDIVIDUAL: "INDIVIDUAL",
  BUSINESS: "BUSINESS",
  UNKNOWN: "UNKNOWN"
};
